export const TEXTAREA_TAG_NAME = "textarea" as const;

export const TEXTAREA_VARIANTS = ["default", "filled"] as const;
